module.exports = {" _key":"@dojo/widgets/popup","root":"popup-m__root__3WJlO","underlay":"popup-m__underlay__2CC_p"};